import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	permissionErrorHeader: {
		id: 'issue-view-errors.new-permission-error-view.permission-error-header',
		defaultMessage: "We can't show this project.",
		description: 'issue view permission error page header',
	},
	permissionErrorDescription: {
		id: 'issue-view-errors.new-permission-error-view.permission-error-description',
		defaultMessage:
			"You don't have permission to view it, or it doesn't exist. Contact your admin to request access.",
		description: 'issue view permission error page description',
	},
	requestAccessButton: {
		id: 'issue-view-errors.new-permission-error-view.request-access-button',
		defaultMessage: 'Request access',
		description: 'issue view permission error page request access button',
	},
	requestAccessSuccessTitle: {
		id: 'issue-view-errors.new-permission-error-view.request-access-success-title',
		defaultMessage: 'Sent access request to admin',
		description: 'Title for successful access request flag',
	},
	requestAccessSuccessAction: {
		id: 'issue-view-errors.new-permission-error-view.request-access-success-action',
		defaultMessage: 'View your work',
		description: 'Description for successful access request flag',
	},
});
